import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import Loader from 'Component/Loader';
import Html from 'Component/Html';
import './LotteryPromoWidget.style.scss';

const initialFormData = {
    email: '',
    receiptNumber: '',
    telephoneNumber: '',
    storeName: '',
    privacyPolicy: true,
    termsAndConditions: true,
    subscribeNewsletter: false
};

const LotteryPromoWidget = ({
                                title,
                                lotteryName,
                                isSubmitting,
                                termsandconditions_link,
                                error,
                                onSubmit,
                                isSignedIn,
                                resetTrigger
                            }) => {
    const [formData, setFormData] = useState(initialFormData);
    const [localError, setLocalError] = useState('');

    const privacyPolicyText = __('I agree with the <a href="%1" target="_blank">Privacy Policy</a>');
    const termsText = __('I agree with the <a href="%1" target="_blank">Terms and Conditions</a>', termsandconditions_link);


   // const privacyPolicyText = __('I agree with the <a href="%1" target="_blank">Privacy Policy</a>');
    const privacyPolicyHtml = privacyPolicyText.replace('%1', '/page/politica-de-confidentialitate');

   // const termsText = __('I agree with the <a href="%1" target="_blank">Terms and Conditions</a>', termsandconditions_link);
    const termsHtml = termsText.replace('%1', termsandconditions_link);

    useEffect(() => {
        // Reset the form and clear local error when resetTrigger changes.
        setFormData(initialFormData);
        setLocalError('');
    }, [resetTrigger]);

    const handleChange = (e) => {
        const { name, value, type, checked } = e.target;
        setFormData({
            ...formData,
            [name]: type === 'checkbox' ? checked : value
        });
    };

    const handleSubmit = (e) => {
        e.preventDefault();

        // Validate email: required and proper email format
        if (!formData.email) {
            setLocalError(__('Email is required.'));
            return;
        }
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (!emailRegex.test(formData.email)) {
            setLocalError(__('Please enter a valid email address.'));
            return;
        }

        // Validate telephone: required and only numbers and optional leading +
        if (!formData.telephoneNumber) {
            setLocalError(__('Phone is required.'));
            return;
        }
        const phoneRegex = /^\+?[0-9]+$/;
        if (!phoneRegex.test(formData.telephoneNumber)) {
            setLocalError(__('Please enter a valid phone number. Only numbers and an optional leading + are allowed.'));
            return;
        }

        // Clear local error and submit the data
        setLocalError('');
        onSubmit({ ...formData, lotteryName });
    };

    if (!isSignedIn) {
        return <p>{__('Please sign in to be able to submit a receipt for the lottery')}</p>;
    }

    return (
        <div className="LotteryPromoWidget">
            <h3 className="LotteryPromoWidget-Title">{title}</h3>
            <div className="LotteryPromoWidget-FormContainer">
                <form onSubmit={handleSubmit} className="LotteryPromoWidget-Form">
                    <div className="LotteryPromoWidget-Field-Text">
                        <div className="LotteryPromoWidget-Field">
                            <label htmlFor="email">{__('Email:')}</label>
                            <input
                                type="email"
                                id="email"
                                name="email"
                                value={formData.email}
                                onChange={handleChange}
                                required
                            />
                        </div>
                        <div className="LotteryPromoWidget-Field">
                            <label htmlFor="telephoneNumber">{__('Phone:')}</label>
                            <input
                                type="text"
                                id="telephoneNumber"
                                name="telephoneNumber"
                                value={formData.telephoneNumber}
                                onChange={handleChange}
                                required
                            />
                        </div>
                        <div className="LotteryPromoWidget-Field">
                            <label htmlFor="storeName">{__('Store Name:')}</label>
                            <input
                                type="text"
                                id="storeName"
                                name="storeName"
                                value={formData.storeName}
                                onChange={handleChange}
                                required
                            />
                        </div>
                        <div className="LotteryPromoWidget-Field">
                            <label htmlFor="receiptNumber">{__('Receipt Number:')}</label>
                            <input
                                type="text"
                                id="receiptNumber"
                                name="receiptNumber"
                                value={formData.receiptNumber}
                                onChange={handleChange}
                                required
                            />
                        </div>
                        {/* Hidden field to send lotteryName */}
                        <input type="hidden" name="lotteryName" value={lotteryName}/>
                    </div>

                    {/* Checkbox for Privacy Policy */}
                    <div className="LotteryPromoWidget-Field-Checkboxes">
                        <div className="LotteryPromoWidget-Field">
                            <label htmlFor="privacyPolicy" className="LotteryPromoWidget-CheckboxLabel">
                                <input
                                    type="checkbox"
                                    id="privacyPolicy"
                                    name="privacyPolicy"
                                    checked={formData.privacyPolicy}
                                    onChange={handleChange}
                                    required
                                />
                                <span
                                    dangerouslySetInnerHTML={{
                                        __html: privacyPolicyHtml
                                    }}
                                />
                            </label>
                        </div>

                        {/* Checkbox for Terms and Conditions */}
                        <div className="LotteryPromoWidget-Field">
                            <label htmlFor="termsAndConditions" className="LotteryPromoWidget-CheckboxLabel">
                                <input
                                    type="checkbox"
                                    id="termsAndConditions"
                                    name="termsAndConditions"
                                    checked={formData.termsAndConditions}
                                    onChange={handleChange}
                                    required
                                />
                                <span
                                    dangerouslySetInnerHTML={{
                                        __html: termsHtml
                                    }}
                                />
                            </label>
                        </div>
                        {/* Checkbox for Newsletter Subscription */}
                        <div className="LotteryPromoWidget-Field">
                        <label htmlFor="subscribeNewsletter" className="LotteryPromoWidget-CheckboxLabel">
                                <input
                                    type="checkbox"
                                    id="subscribeNewsletter"
                                    name="subscribeNewsletter"
                                    checked={formData.subscribeNewsletter}
                                    onChange={handleChange}
                                />
                                <span>{__('Subscribe to our Newsletter to get information about new promotions')}</span>
                            </label>
                        </div>
                    </div>

                    {error || localError ? (
                        <div className="LotteryPromoWidget-Error">{localError || error}</div>
                    ) : null}
                    <button type="submit" className="LotteryPromoWidget-Button">
                        {__('Submit Receipt')}
                    </button>
                </form>
                {isSubmitting && (
                    <div className="LoaderOverlay">
                        <Loader isLoading={true}/>
                    </div>
                )}
            </div>
        </div>
    );
};

LotteryPromoWidget.propTypes = {
    title: PropTypes.string.isRequired,
    lotteryName: PropTypes.string.isRequired,
    isSubmitting: PropTypes.bool,
    error: PropTypes.string,
    onSubmit: PropTypes.func.isRequired,
    isSignedIn: PropTypes.bool.isRequired,
    resetTrigger: PropTypes.number.isRequired,
    termsandconditions_link: PropTypes.string.isRequired
};

export default LotteryPromoWidget;
